import React from "react";

function ConsultantTypeStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="col-lg-12">
          <div className="pt-3 mt-3">
            <h2 className="h6 pb-1 mb-3 color_grey">
              Great! Let's Narrow This Step Down.
            </h2>
            {/* Required Field: Must choose one. */}
            <div className="nav nav-pills row row-cols-2 row-cols-sm-3 row-cols-md-3 gap-0 g-3">
              {/* Enterprise Software Systems */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="business-software"
                  name="consultant-category"
                  value="Enterprise Software Systems"
                  onChange={handleChange}
                  checked={
                    formData["consultant-category"] ===
                    "Enterprise Software Systems"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="business-software"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/erp.svg"
                    alt="ERP"
                  ></img>
                  <div className="main_card_info">
                    <h3>Enterprise Software Systems</h3>
                    <p>
                      Information and Management Systems, Business Intelligence
                      Solutions, Outsourcing Support, Algorithm Development.
                    </p>
                  </div>
                </label>
              </div>

              {/* Data Management and Analysis */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="manage-data"
                  name="consultant-category"
                  value="Data Management and Analysis"
                  onChange={handleChange}
                  checked={
                    formData["consultant-category"] ===
                    "Data Management and Analysis"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="manage-data"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/manage_data.svg"
                    alt="Data Management"
                  ></img>
                  <div className="main_card_info">
                    <h3>Data Management and Analysis</h3>
                    <p>
                      Data Analysis, Data Visualization, Big Data, Data Mining,
                      Data Architecture.
                    </p>
                  </div>
                </label>
              </div>

              {/* Technology Consulting */}
              <div className="col">
                <input
                  type="radio"
                  className="btn-check"
                  id="tech-consulting"
                  name="consultant-category"
                  value="Technology Consulting"
                  onChange={handleChange}
                  checked={
                    formData["consultant-category"] === "Technology Consulting"
                  }
                />
                <label
                  className="nav-link flex-column w-100 align-items-center gap-2 rounded p-3"
                  htmlFor="tech-consulting"
                >
                  <img
                    className="main__icon"
                    src="/assets/icons/tech-consult.svg"
                    alt="Technology Consulting"
                  ></img>
                  <div className="main_card_info">
                    <h3>Technology Consulting</h3>
                    <p>
                      Current System Analysis, ERP / CRM Needs Analysis,
                      Database Analysis, IT Budget Management.
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConsultantTypeStep;
